import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { PaymentPlanAcceptMonth } from 'src/app/models/PaymentPlanAcceptMonth';

@Injectable({
    providedIn: 'root'
})
export class PaymentPlanAcceptMonthApi extends Api<PaymentPlanAcceptMonth> {
    
}